
import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import BaseAutocomplete from '@/components/select/BaseAutocomplete.vue';

import { buildParams } from '@/api/formatter';

import { Doctors } from '@/models/doctors';

import { LoadPropType, SelectValue } from '@/components/select/types';
import { ConsultationRequest } from '@/types/consultations';
import { generateFilter } from '@/utils/filter';

const actualScheduleFilterItem = {
    id: 'hasActualSchedule',
    value: '1',
    index: 2,
};

@Component({
    components: {
        BaseAutocomplete,
    }
})
export default class RequestDoctor extends Vue {
    @Model('update:value', { required: true }) value!: SelectValue;
    @Prop({ required: false }) specialization?: ConsultationRequest['specialization']
    @Prop({ required: false }) request?: ConsultationRequest

    get valueModel() {
        return this.value;
    }

    set valueModel(value) {
        this.$emit('update:value', value);
    }

    get filterItems() {
        const dateFilters = this.request?.time ? [
            {
                id: 'workTimeStartsBefore',
                value: this.request.time.start,
                index: 3,
            },
            {
                id: 'workTimeEndedAfter',
                value: this.request.time.end,
                index: 4,
            },
            {
                id: 'withSlotChecking',
                value: 1,
                index: 5,
            },
        ] : [];

        return [actualScheduleFilterItem, ...dateFilters];
    }

    get autocompleteSettings(): LoadPropType {
        return {
            entityName: Doctors.moduleName,
            filterName: 'fullName',
            formatParams: (search, key) => buildParams({
                specialization: this.specialization?.id,
                [key]: search,
            }),
            filterString: generateFilter(this.filterItems),
        }
    }
}
